import React, { useState } from "react";

import SectionHeader from "../SectionHeader";
import Form from "../Form";

import "./index.scss";
import { FadeLoader } from "react-spinners";

function DataConfirmation({ handleChangeStep }) {
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [step, setStep] = useState("minute");
  function handleGoToSignature() {
    handleChangeStep(7);
  }

  function handleGoBack() {
    // if (previousStep === 8) {
    //   handleChangeStep(8)
    //   return
    // }

    handleChangeStep(3);
  }

  if (isSubmiting) {
    return (
      <div className="loading-submit">
        <div className="loading-submit__container">
          <div>
            <FadeLoader color="#fff" width={4} height={12} />
            <h2>
              {step === "minute"
                ? "Estamos gerando a minuta"
                : "Estamos gerando seu boleto"}
            </h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="data-confirmation">
      <main>
        <SectionHeader handleGoBack={handleGoBack}>
          <h2>Preencha seus dados</h2>
        </SectionHeader>
        <section className="data-confirmation__container-form">
          <Form
            btnTitle="Continuar"
            handleCallback={handleGoToSignature}
            handleIsSubmit={setIsSubmiting}
            type="payment"
            isSubmiting={isSubmiting}
            setStep={setStep}
          />
        </section>
      </main>
    </div>
  );
}

export default DataConfirmation;
